import { Vob } from "@finpay-estimation/estimation-types";
import {
    ClientCrm,
    ClientStatusCardViewModel,
} from "src/shared/model/client-status-card";
import { axiosSaveHelper } from "src/shared/service/axios-save-helper";
import { AxiosSavePayload } from "src/shared/service/axios-save-payload";
import { AxiosResultStatus } from "src/shared/service/axios-result-status";

export function checkIntegrationFeatureFlag(clientCrm: ClientCrm[]): boolean {
    return !!clientCrm?.[0]?.isIntEnabled;
}

export function getClientCrmDetails(
    currentClientId: number | undefined,
    allClients: ClientStatusCardViewModel[]
): ClientCrm[] {
    const clientItem = allClients?.find(
        (client) => client.clientId === currentClientId
    );
    return clientItem?.clientCrm ?? [];
}

/** Patient fields used when building the CRM VOB outbound payload. */
export interface CrmVobSyncPatient {
    firstName: string;
    lastName: string;
    birthDate: string | null | undefined;
}

/**
 * POST `{crmTypeSlug}/event/vob` on the unified API gateway (same as `patientService.integrationVOBUpdate`).
 */
export async function integrationVOBUpdate(data: {
    vob: Record<string, unknown>;
    crmTypeSlug?: string;
}): Promise<AxiosResultStatus> {
    const payload: AxiosSavePayload = {
        dataToSave: data.vob,
        dataId: 0,
        url: `${data.crmTypeSlug}/event/vob`,
    };
    return axiosSaveHelper(payload);
}

/**
 * Builds the body for {@link integrationVOBUpdate}.
 */
export function buildCrmVobUpdatePayload(
    aaVOB: Vob,
    clientsPatientAccountId: string | null,
    clientsPatientIOCId: string | null,
    client: Record<string, unknown>,
    facility: Record<string, unknown>,
    patient: CrmVobSyncPatient
): Record<string, unknown> {
    const formedVob: Record<string, unknown> = { ...aaVOB };
    delete formedVob.client;
    delete formedVob.facility;
    const birthDateISO = new Date(patient.birthDate!).toISOString();
    return {
        client,
        facility,
        vob: formedVob,
        clientsPatientAccountId,
        clientsPatientIocId: clientsPatientIOCId,
        patient: {
            firstName: patient.firstName,
            lastName: patient.lastName,
            birthDate: birthDateISO,
        },
    };
}
